export default __webpack_public_path__ + "static/media/google.cd676080.svg";